import { useTranslation } from 'react-i18next';
import useRouteBasedStepperLayout from 'components/Stepper/RouteBasedStepper/useRouteBasedStepperLayout';
import { useCreateCaseState } from 'datasource/CaseManagement/CreateCaseManager';
import { useMemo } from 'react';
import useCreateNewCaseFlow from './useCreateNewCaseFlow';

export const useCreateNewCaseLayout = () => {
    const { t } = useTranslation();
    const { stepsBasedOnState } = useCreateNewCaseFlow();
    const { currentPortfolioSelector, mainOwner, jaClient } = useCreateCaseState();

    const footerAdditionalInfo = useMemo(() => [
        {
            label: 'portfolio.createNewPortfolio.clientName',
            values: [mainOwner?.name ?? '-', ...[jaClient?.name]],
        },
        {
            label: 'portfolio.createNewPortfolio.clientAge',
            values: [mainOwner?.age?.toString() ?? '-', ...[jaClient?.age?.toString()]],
        },
    ], [mainOwner, jaClient]);

    const {
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        contentTitle,
        contentClassName,
        isStepperEnabled,
        isFooterSimplified,
        onContinue,
        onBack,
        continueDisabled,
        isContinueLoading,
        backDisabled,
        hideStepperButtons,
        productType,
    } = useRouteBasedStepperLayout({
        title: t('Layout.CreateNewCase.Sidebar.Title'),
        productType: currentPortfolioSelector?.Name,
        stepsBasedOnState,
    });

    return {
        footerAdditionalInfo,
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        onBack,
        onContinue,
        continueDisabled,
        backDisabled,
        inProgress: isContinueLoading,
        isStepperEnabled,
        isFooterSimplified,
        contentTitle,
        contentClassName,
        hideStepperButtons,
        productType,
        startDate: null,
        minStartDate: null,
        allowJumpStep: false,
    };
};
